const styles = () => ({
  buttonUser: {}
});

export default styles;
